import PropTypes from "prop-types";
import { memo } from "react";
// @mui
import { Stack } from "@mui/material";
//
import { NavListRoot } from "./NavList";
import OrgPopover from "src/layouts/dashboard/header/OrgPopover";
import { useSelector } from "react-redux";

// ----------------------------------------------------------------------

const hideScrollbar = {
  msOverflowStyle: "none",
  scrollbarWidth: "none",
  overflowY: "scroll",
  "&::-webkit-scrollbar": {
    display: "none",
  },
};

NavSectionHorizontal.propTypes = {
  navConfig: PropTypes.array,
};

function NavSectionHorizontal({ navConfig }) {
  const { userInOrganisation } = useSelector(state => state.user)

  return (
    <Stack direction="row" justifyContent="center" sx={{ height: "100%" }}>
      <Stack direction="row" alignItems={'center'} sx={{ ...hideScrollbar, py: 0 }}>
        {navConfig.map((group) => (
          <Stack
            key={group.subheader}
            direction="row"
            flexShrink={0}
            sx={{ height: "100%" }}
            alignItems={'center'}
          >
            {group.items.map((list, index) => (
              <>
                {index === 1 && <OrgPopover></OrgPopover>}
                <NavListRoot key={list.title} list={list} />
                {/* {
                  !userInOrganisation?.restricted ? <NavListRoot key={list.title} list={list} /> : list.showOnRestricted ? <NavListRoot key={list.title} list={list} /> : <></>
                } */}
              </>
            ))}
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}

export default memo(NavSectionHorizontal);
